import React, { ReactElement } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import Radio from './radio'
import { useField } from 'formik'

const useStyles = makeStyles((theme) => ({
  checkbox: {
    padding: theme.spacing(3),
    '&:hover': {
      backgroundColor: 'transparent',
    },

    '.has-error &': {
      color: theme.palette.error.dark,
    },
  },
  icon: {
    backgroundColor: theme.palette.background.main,
    borderRadius: 2,
    width: theme.spacing(6),
    height: theme.spacing(6),
    position: 'relative',

    '&.disabled': {
      backgroundColor: theme.palette.background.light,
    },
  },
  checkedIcon: {
    color: theme.palette.secondary.dark,
    position: 'absolute',
    top: '50%',
    left: theme.spacing(-0.5),
    transform: 'translateY(-45%)',
  },
}))

export type RadioFieldProps = RvG.IReactDefaultProps & {
  value?: string | undefined
  name: string
  disabled?: boolean | false
  checked?: boolean
  id?: string
  label: string
}

export default function RadioField({
  name,
  ...props
}: RadioFieldProps): ReactElement {
  const classes = useStyles()
  // const [field, meta] = useField(name)
  return (
    <>
      <Radio name={name} {...props} />
    </>
  )
}
